module.exports = __webpack_public_path__ + "6d0b27b81c91fa5f0f45106f61925853.svg";